import LeadMessagesContainer from './LeadMessagesContainer';
export default LeadMessagesContainer;